import { messagesToIgnore } from '../constants/messagesToIgnore';
import { ShouldDropEventProps } from '../types/ShouldDropEventProps';

const UNLEASH_HOST = 'us.app.unleash-hosted.com';

/**
 * Vendor-neutral pre-send filter. Decides whether an outgoing event is
 * known-noisy and should be dropped before it ships to the dashboard.
 *
 * Currently drops:
 *   - Events whose message matches any entry in `messagesToIgnore`.
 *   - Unleash polling failures (network errors or timeouts hitting the
 *     hosted Unleash endpoint).
 */
export const shouldDropEvent = ({
  errorCode = '',
  errorMessage = '',
  errorRequestUrl = '',
}: ShouldDropEventProps): boolean => {
  const isNetworkError = errorCode === 'ERR_NETWORK';
  const isTimeoutError = errorCode === 'ECONNABORTED';

  const matchesIgnoredMessage = messagesToIgnore.some((message): boolean =>
    errorMessage.includes(message),
  );

  const isUnleashFailure =
    (isNetworkError || isTimeoutError) &&
    errorRequestUrl.includes(UNLEASH_HOST);

  return matchesIgnoredMessage || isUnleashFailure;
};
